<template>
  <div class="transaction">
    <div class="row">
      <div
        class="col-md-6 col-xl-3"
        v-for="stats in statsCards"
        :key="stats.title"
      >
        <stats-card>
          <div
            class="icon-big text-center"
            :class="`icon-${stats.type}`"
            slot="header"
          >
            <i :class="stats.icon"></i>
          </div>
          <div class="numbers" slot="content">
            <p>{{ stats.title }}</p>
            {{ stats.value }}
          </div>
          <div class="stats" slot="footer">
            <i :class="stats.footerIcon"></i> {{ stats.footerText }}
          </div>
        </stats-card>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex align-items-center">
        <div class="form-row align-items-center">
          <div class="col-auto">
            <label for="inlineFormInput">Status</label>
            <select class="form-control" v-model="status">
              <option value="">Select Status</option>
              <option value="successful">Successful</option>
              <option value="failed">Failed</option>
              <option value="pending">Pending</option>
              <option value="reversed">Reversed</option>
            </select>
          </div>

          <div class="col-auto">
            <label for="inlineFormInput">Product</label>
            <select class="form-control" v-model="product">
              <option value="">Select a Product</option>
              <option value="withdrawal">Withdrawal</option>
              <option value="ikedc">Ikedc</option>
              <option value="ekedc">Ekedc</option>
              <option value="eedc">Eedc</option>
              <option value="ibedc">Ibedc</option>
              <option value="phedc">Phedc</option>
              <option value="aedc">Aedc</option>
              <option value="kedco">Kedco</option>
              <option value="mtnvtu">Mtnvtu</option>
              <option value="airtelvtu">Airtelvtu</option>
              <option value="9mobilevtu">9mobilevtu</option>
              <option value="glovtu">Glovtu</option>
              <option value="mtndata">Mtndata</option>
              <option value="glodata">Glodata</option>
              <option value="airteldata">Airteldata</option>
              <option value="9mobiledata">9mobiledata</option>
              <option value="multichoice">Multichoice</option>
              <option value="startimes">Startimes</option>
              <option value="smile">Smile</option>
              <option value="transfer">Transfer</option>
            </select>
          </div>

          <div class="col-auto">
            <label for="inlineFormInput">Limit</label>
            <select class="form-control" v-model="limit">
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="300">300</option>
              <option value="500">500</option>
            </select>
          </div>

          <div
            class="col-auto mt-2"
            v-if="
              auth.user.adminType === 'super-admin' ||
              auth.user.adminType === 'admin'
            "
          >
            <label>Agent Id</label>
            <div class="input-group mb-2">
              <input
                type="text"
                class="form-control"
                id="inlineFormInputGroup"
                placeholder="Agent Id"
                v-model="agentId"
              />
            </div>
          </div>

          <div class="col-auto">
            <label for="inlineFormInput">Filter By:</label>
            <select
              class="form-control"
              v-model="selectedValue"
              placeholder="Select a search parameter"
            >
              <option value="">Select a search parameter</option>
              <option value="reference">Reference</option>
              <option value="walletId">Wallet Id</option>
            </select>
          </div>

          <div class="col-auto mt-4" v-if="selectedValue">
            <label for="inlineFormInput">Enter Value</label>
            <div class="input-group">
              <input
                id="inlineFormInputGroup"
                class="form-control"
                v-model="searchValues[selectedValue]"
                :placeholder="`Enter ${selectedValue.replace(/Id/g, ' Id')}`"
                type="text"
              />
            </div>
          </div>

          <div class="col-auto mt-2">
            <label>Start Date</label>
            <div class="input-group mb-2">
              <input
                type="date"
                class="form-control"
                id="inlineFormInputGroup"
                placeholder="Start Date"
                v-model="startDate"
              />
            </div>
          </div>

          <div class="col-auto mt-2">
            <label>End Date</label>
            <div class="input-group mb-2">
              <input
                type="date"
                class="form-control"
                id="inlineFormInputGroup"
                placeholder="End Date"
                v-model="endDate"
              />
            </div>
          </div>

          <div class="col-auto mt-2">
            <button
              type="submit"
              class="btn btn-primary mb-2 mt-4"
              @click="refresh('filter')"
            >
              Filter
            </button>
          </div>
          <div class="col-auto mt-2">
            <button
              type="submit"
              class="btn btn-primary mb-2 mt-4"
              @click="refresh('download')"
            >
              Download
            </button>
          </div>
          <div class="col-auto mt-2">
            <button class="btn btn-info mb-2 mt-4" @click="refresh('refresh')">
              Refresh
            </button>
          </div>
        </div>
      </div>

      <div class="spinner-grow" role="status" v-if="loading === true"></div>
      <div class="alert alert-danger" role="alert" v-if="error === true">
        {{ errorMsg }}
      </div>
      <!-- <h4>Transactions</h4> -->

      <div class="col-12">
        <card class="card-plain">
          <div class="table-full-width table-responsive">
            <table class="table">
              <thead class="tms-dark">
                <tr>
                  <th scope="col" class="text-center">S/N</th>
                  <th scope="col" class="text-center">Product</th>
                  <th scope="col" class="text-center">Wallet Id</th>
                  <th scope="col" class="text-center">Account Number</th>
                  <th scope="col" class="text-center">Account Name</th>
                  <th scope="col" class="text-center">Bank Name</th>
                  <th scope="col" class="text-center">Amount</th>
                  <th scope="col" class="text-center">Transaction ID</th>
                  <th scope="col" class="text-center">Provider</th>
                  <th scope="col" class="text-center">Provider's Reference</th>
                  <th scope="col" class="text-center">Provider's Status</th>
                  <th scope="col" class="text-center">Account Type</th>
                  <th scope="col" class="text-center">Narration</th>
                  <th scope="col" class="text-center">Status</th>
                  <th scope="col" class="text-center">Date</th>
                  <th scope="col" class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <VasTransModal
                  :show-trans-detail="showTransDetail"
                  :close-modal="closeModal"
                  :modal-trans-detail="modalTransDetail"
                />
                <tr
                  v-for="(transaction, index) in filteredTransactions"
                  :key="transaction._id"
                  class="trans-detail"
                >
                  <th class="text-center">
                    {{ limit * (page - 1) + (index + 1) }}
                  </th>
                  <td class="text-center">
                    {{ transaction.product.toUpperCase() }}
                  </td>
                  <td class="text-center">{{ transaction.walletId }}</td>
                  <td class="text-center">{{ transaction.account }}</td>
                  <td class="text-center">{{ transaction.accountName }}</td>
                  <td class="text-center">{{ transaction.bankName }}</td>
                  <td class="text-center">
                    {{ `₦${format.format(transaction.amount.toFixed(2))}` }}
                  </td>
                  <td class="text-center">
                    {{ transaction.reference }}
                  </td>
                  <td class="text-center">
                    {{ transaction.provider || "N/A" }}
                  </td>
                  <td class="text-center">
                    {{
                      transaction.response && transaction.response.reference
                        ? transaction.response.reference
                        : "NULL"
                    }}
                  </td>
                  <td class="text-center">
                    {{
                      transaction.response && transaction.response.statusCode
                        ? transaction.response.statusCode
                        : transaction.response &&
                          transaction.response.responseCode
                        ? transaction.response.responseCode
                        : "NULL"
                    }}
                  </td>
                  <td class="text-center">
                    {{ transaction.accountType || "NULL" }}
                  </td>
                  <td class="text-center">{{ transaction.narration }}</td>
                  <td class="text-center">
                    <button :class="getStatusClass(transaction.status)">
                      {{ transaction.status }}
                    </button>
                  </td>

                  <td class="text-center">
                    {{
                      moment
                        .utc(transaction.createdAt)
                        .format("YYYY-MM-DD, hh:mm:ss a")
                    }}<!--  removed utc to display in local time -->
                  </td>
                  <td>
                    <button
                      class="btn btn-info"
                      @click="updateModal(true, transaction)"
                    >
                      View Details
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </card>
      </div>
      <!-- pagination -->
      <div
        class="pagination"
        style="justify-content: space-between; width: 100%"
      >
        <div
          class="to-flex"
          style="display: flex; align-items: center; gap: 10px"
        >
          <button
            class="btn"
            :disabled="hasPrevPage === false"
            @click="refresh('previous')"
          >
            Previous
          </button>

          <span>Page {{ currentPage }} of {{ totalPages }}</span>

          <button class="btn" :disabled="!hasNextPage" @click="refresh('next')">
            Next
          </button>
        </div>

        <div class="p-2">
          <div class="btn">Total Records: {{ totalDocs }}</div>
        </div>
      </div>
      <!-- <div class="mt-2 paginate-btns">
        <div class="p-2">
          <button
            type="submit"
            class="btn btn-primary mb-2 mt-4"
            @click="refresh('previous')"
          >
            Prev
          </button>
        </div>

        <div>Page {{ currentPage }} of {{ totalPages }}</div>

        <div class="p-2" v-if="hasNextPage === true">
          <button
            type="submit"
            class="btn btn-primary mb-2 mt-4"
            @click="refresh('next')"
          >
            Next
          </button>
        </div>
      </div>

      <div class="mt-2 d-flex justify-content-end align-items-center">
        <div class="p-2">
          <div class="btn">Total Records: {{ totalDocs }}</div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import axios from "../store/axios";
import moment from "moment";
import fileDownload from "js-file-download";
import { convertArrayToCSV } from "convert-array-to-csv";
import { mapActions, mapState } from "vuex";
import { StatsCard } from "@/components/index";
import VasTransModal from "./Modals/VasTransModal.vue";

export default {
  components: {
    StatsCard,
    VasTransModal,
  },
  data() {
    return {
      // pagination
      currentPage: 1,
      itemsPerPage: 30,

      //modal
      showTransDetail: false,
      modalTransDetail: {},

      statsCards: [
        {
          type: "info",
          icon: "ti-save",
          title: "Total",
          value: "₦0",
          footerText: `0`,
          footerIcon: "ti-reload",
        },
        {
          type: "primary",
          icon: "ti-wallet",
          title: "Successful",
          value: "₦0",
          footerText: "0",
          footerIcon: "ti-reload",
          // color: "green"
        },
        {
          type: "warning",
          icon: "ti-server",
          title: "Pending",
          value: "₦0",
          footerText: "0",
          footerIcon: "ti-reload",
        },
        {
          type: "danger",
          icon: "ti-pulse",
          title: "Failed",
          value: "₦0",
          footerText: "0",
          footerIcon: "ti-reload",
        },
      ],
      error: false,
      transactions: [],
      errorMsg: "",
      loading: false,
      moment,
      format: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      page: 1,
      limit: 50,
      totalPages: 0,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: null,
      totalDocs: 0,
      pageNumbers: [],
      status: "",
      terminalId: "",
      searchValues: {
        walletId: "",
        reference: "",
      },
      agentId: "",
      stan: "",
      product: "",
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      unsentList: [],
      allChecked: false,
      selectedValue: "",
      filteredTransactions: [],
    };
  },
  computed: {
    ...mapState(["auth"]),
  },
  methods: {
    ...mapActions(["setNotification"]),
    handleSearch(term) {
      if (term) {
        this.filteredTransactions = this.transactions.filter((transaction) => {
          let productMatch;
          let walletIdMatch;
          let accountMatch;
          if (transaction.product) {
            productMatch = transaction.product
              .toLowerCase()
              .includes(term.toLowerCase());
          }
          if (transaction.walletId) {
            walletIdMatch = transaction.walletId
              .toLowerCase()
              .includes(term.toLowerCase());
          }
          if (transaction.account) {
            accountMatch = transaction.account
              .toLowerCase()
              .includes(term.toLowerCase());
          }
          return productMatch || walletIdMatch || accountMatch;
        });
      } else {
        this.filteredTransactions = this.transactions;
      }
    },
    updateModal(showTD, tran) {
      this.showTransDetail = showTD;
      this.modalTransDetail = tran;
    },
    closeModal() {
      this.showTransDetail = false;
    },
    getStatusClass(status) {
      return {
        "text-center": true,
        "status-btn": true,
        failure: status === "failed",
        pending: status === "pending",
        success: status === "successful",
      };
    },
    async refresh(mode) {
      try {
        this.loading = true;
        if (mode === "filter" || mode === "refresh") {
          this.page = 1;
          this.currentPage = 1;
        }
        if (mode === "refresh") {
          this.startDate = moment().format("YYYY-MM-DD");
          this.endDate = moment().format("YYYY-MM-DD");
        }
        let payload = {
          page: this.page,
          status: this.status,
          terminalId: this.terminalId,
          agentId: this.agentId,
          stan: this.stan,
          product: this.product,
          startDate: this.startDate,
          endDate: this.endDate,
          limit: this.limit,
          ...this.searchValues,
        };

        if (typeof mode === "number") {
          payload = { ...payload, page: mode };
        } else {
          switch (mode) {
            case "next":
              payload = { ...payload, page: this.nextPage };
              this.currentPage = this.nextPage;
              break;
            case "previous":
              payload = { ...payload, page: this.prevPage };
              this.currentPage = this.prevPage;
              break;
            case "download":
              payload = { ...payload, download: true };
              break;
          }
        }
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/transactions/vas-reports`,
          payload,
        );
        if (mode === "download") {
          const csvTran = convertArrayToCSV(res.data.transactions);
          fileDownload(csvTran, "transactions.csv");
        } else {
          const {
            docs,
            hasNextPage,
            hasPrevPage,
            totalPages,
            prevPage,
            nextPage,
            totalDocs,
            page,
          } = res.data.transactions;
          this.transactions = docs;
          this.filteredTransactions = docs;
          this.hasPrevPage = hasPrevPage;
          this.hasNextPage = hasNextPage;
          this.totalPages = totalPages;
          this.prevPage = prevPage;
          this.nextPage = nextPage;
          this.totalDocs = totalDocs;
          this.page = page;
          const {
            failed,
            successful,
            total,
            pending,
            successfulCount,
            failedCount,
            pendingCount,
          } = res.data.summary;
          this.statsCards[0].value = `₦${this.format.format(total.toFixed(2))}`;
          this.statsCards[0].footerText = this.totalDocs;
          this.statsCards[1].value = `₦${this.format.format(
            successful.toFixed(2),
          )}`;
          this.statsCards[1].footerText = successfulCount;
          this.statsCards[2].value = `₦${this.format.format(
            pending.toFixed(2),
          )}`;
          this.statsCards[2].footerText = pendingCount;
          this.statsCards[3].value = `₦${this.format.format(
            failed.toFixed(2),
          )}`;
          this.statsCards[3].footerText = failedCount;
        }
      } catch (error) {
        if (error.response && error.response.data) {
          const { message } = error.response.data;
          this.setNotification({ type: "danger", message });
        } else {
          this.setNotification({
            type: "danger",
            message: "Unable to Fetch Transactions",
          });
        }
      }
      this.loading = false;
    },
    clearSearchFields() {
      this.searchValues = { walletId: "", reference: "" };
    },
  },
  watch: {
    selectedValue() {
      this.clearSearchFields();
      this.refresh("filter");
    },
  },
  async mounted() {
    try {
      this.loading = true;
      const res = await axios.post(
        `${process.env.VUE_APP_API_URL}/transactions/vas-reports`,
        {
          page: this.page,
          startDate: this.startDate,
          endDate: this.endDate,
          limit: this.limit,
        },
      );
      const {
        docs,
        hasNextPage,
        hasPrevPage,
        totalPages,
        prevPage,
        nextPage,
        totalDocs,
        page,
      } = res.data.transactions;
      this.transactions = docs;
      this.filteredTransactions = docs;
      this.hasPrevPage = hasPrevPage;
      this.hasNextPage = hasNextPage;
      this.totalPages = totalPages;
      this.prevPage = prevPage;
      this.nextPage = nextPage;
      this.totalDocs = totalDocs;
      this.page = page;
      const {
        failed,
        successful,
        total,
        pending,
        successfulCount,
        failedCount,
        pendingCount,
      } = res.data.summary;
      this.statsCards[0].value = `₦${this.format.format(total.toFixed(2))}`;
      this.statsCards[0].footerText = this.totalDocs;
      this.statsCards[1].value = `₦${this.format.format(
        successful.toFixed(2),
      )}`;
      this.statsCards[1].footerText = successfulCount;
      this.statsCards[2].value = `₦${this.format.format(pending.toFixed(2))}`;
      this.statsCards[2].footerText = pendingCount;
      this.statsCards[3].value = `₦${this.format.format(failed.toFixed(2))}`;
      this.statsCards[3].footerText = failedCount;
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        const { message } = error.response.data;
        this.setNotification({ type: "danger", message });
      } else {
        this.setNotification({
          type: "danger",
          message: "Unable to Fetch Transactions",
        });
      }
    }
    this.loading = false;
  },
};
</script>
<style scoped>
.transaction {
  font-size: 12px;
}
th {
  font-size: 12px !important;
}
.spinner-grow {
  position: fixed;
}
tbody {
  background: #fff !important;
}
.tms-dark {
  background-color: #333f48;
  color: #fff;
}
.ref {
  font-size: 8px;
}
button {
  padding: 0.2rem 10px !important;
}
.list {
  list-style-type: none;
}
.status-btn {
  padding: 10px 15px !important;
  border: none;
  border-radius: 5px;
}
.success {
  background-color: rgb(7, 133, 7);
  color: #fff;
  font-weight: bolder;
}
.failure {
  background-color: rgb(217, 16, 16);
  color: #fff;
  font-weight: bolder;
}
.pending {
  background-color: rgb(246, 246, 17);
  font-weight: bolder;
}
.paginate-btns {
  display: flex;
  grid-gap: 40px;
}
</style>
